const services = [
  {
    icon: 'ri-file-chart-line',
    title: '사업계획 및 타당성 분석',
    description: '정부 과제 및 투자 유치를 위한 논리적 기획',
    features: [
      '사업타당성 분석 및 시장조사',
      '정부 R&D 과제 사업계획서 작성',
      '투자 유치용 IR 자료 제작',
      '사업 전략 수립 및 실행 계획'
    ]
  },
  {
    icon: 'ri-line-chart-line',
    title: '재무 관리',
    description: '정책자금(융자) 연계 및 재무 구조 최적화',
    features: [
      '재무제표 분석 및 개선 방안',
      '정책자금 융자 신청 지원',
      '자금 조달 전략 수립',
      '재무 건전성 진단 및 컨설팅'
    ]
  },
  {
    icon: 'ri-flask-line',
    title: 'R&D 과제 컨설팅',
    description: '기업부설연구소 설립 및 R&D 사업계획서 작성 지도',
    features: [
      '기업부설연구소 설립 지원',
      'R&D 과제 발굴 및 기획',
      '정부 R&D 사업계획서 작성',
      '연구개발 전략 수립'
    ]
  },
  {
    icon: 'ri-shield-check-line',
    title: '안전보건체계',
    description: '중대재해처벌법 대응 및 위험성평가 컨설팅',
    features: [
      '중대재해처벌법 대응 체계 구축',
      '위험성평가 실시 및 개선',
      '안전보건관리체계 수립',
      '안전보건 교육 및 훈련'
    ]
  }
];

export default function Consulting() {
  return (
    <section id="consulting" className="py-12 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-900 mb-3 md:mb-4">
            경영 컨설팅
          </h2>
          <p className="text-sm md:text-base lg:text-lg text-gray-600 max-w-2xl mx-auto">
            기업의 지속 가능한 성장을 위한 맞춤형 컨설팅
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-16">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-white to-gray-50 rounded-xl p-8 shadow-sm hover:shadow-2xl transition-all duration-300 border border-gray-200 cursor-pointer group"
            >
              <div className="flex items-start gap-6 mb-6">
                <div className="w-16 h-16 bg-teal-100 rounded-xl flex items-center justify-center flex-shrink-0 group-hover:bg-teal-500 transition-colors">
                  <i className={`${service.icon} text-3xl text-teal-600 group-hover:text-white transition-colors`}></i>
                </div>
                <div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-2">{service.title}</h3>
                  <p className="text-gray-600">{service.description}</p>
                </div>
              </div>

              <div className="space-y-3 pl-2">
                {service.features.map((feature, idx) => (
                  <div key={idx} className="flex items-start gap-3">
                    <i className="ri-check-line text-teal-600 mt-1 flex-shrink-0"></i>
                    <span className="text-gray-700">{feature}</span>
                  </div>
                ))}
              </div>

              <div className="mt-6 pt-6 border-t border-gray-200">
                <a
                  href="#contact"
                  className="text-teal-600 font-semibold inline-flex items-center gap-2 cursor-pointer hover:gap-3 transition-all whitespace-nowrap"
                >
                  컨설팅 문의하기
                  <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-br from-teal-600 to-teal-700 rounded-2xl p-8 md:p-12 text-white">
          <div className="grid lg:grid-cols-2 gap-8 md:gap-12 items-center">
            <div>
              <h3 className="text-2xl md:text-3xl font-bold mb-4 md:mb-6 leading-tight">
                30년 경험의 전문가가 귀사의 성장을 설계합니다
              </h3>
              <p className="text-white/90 text-base md:text-lg leading-relaxed mb-6 md:mb-8">
                단순한 이론이 아닌, 정부 부처 평가위원 활동을 통한 '되는' 전략을 제시합니다. 
                경영지도사, 국제공인경영컨설턴트(CMC), ISO 국제선임심사원 자격을 보유한 
                이광철 박사와 각 분야 전문가들이 귀사의 전략적 파트너가 되겠습니다.
              </p>
              <a
                href="#contact"
                className="inline-flex items-center gap-2 px-6 py-3 md:px-8 md:py-4 bg-white text-teal-600 font-semibold rounded-lg hover:bg-gray-100 transition-all shadow-lg cursor-pointer whitespace-nowrap text-sm md:text-base"
              >
                전문가 상담 신청
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>

            <div className="space-y-4 md:space-y-6">
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-5 md:p-6">
                <div className="flex items-center gap-3 md:gap-4 mb-2 md:mb-3">
                  <div className="w-10 h-10 bg-white/20 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-user-star-line text-xl md:text-2xl"></i>
                  </div>
                  <h4 className="text-lg md:text-xl font-bold">전문 자격 보유</h4>
                </div>
                <p className="text-white/90 text-sm md:text-base leading-relaxed">
                  경영지도사, CMC, ISO 국제선임심사원 등 검증된 전문 자격 보유
                </p>
              </div>

              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-5 md:p-6">
                <div className="flex items-center gap-3 md:gap-4 mb-2 md:mb-3">
                  <div className="w-10 h-10 bg-white/20 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-government-line text-xl md:text-2xl"></i>
                  </div>
                  <h4 className="text-lg md:text-xl font-bold">정부 평가위원 활동</h4>
                </div>
                <p className="text-white/90 text-sm md:text-base leading-relaxed">
                  중기부, 산자부, 창업진흥원 R&D 평가위원으로 활동 중
                </p>
              </div>

              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-5 md:p-6">
                <div className="flex items-center gap-3 md:gap-4 mb-2 md:mb-3">
                  <div className="w-10 h-10 bg-white/20 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className="ri-trophy-line text-xl md:text-2xl"></i>
                  </div>
                  <h4 className="text-lg md:text-xl font-bold">검증된 실적</h4>
                </div>
                <p className="text-white/90 text-sm md:text-base leading-relaxed">
                  800여 건 이상의 성공 레퍼런스와 국토교통부장관 표창 수상
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
